// extracted by mini-css-extract-plugin
export default {"email-screen":"email_email-screen__z7ixJ"};